import { makeStyles } from "@material-ui/core";
import { colors } from "~/utils/colors";

const { brand } = colors;

const MuiStylesCardReservations = makeStyles((theme) => ({
	// Header and Tabs Wrapper
	headerWrapper: {
		background: "linear-gradient(135deg, #8B1538 0%, #6B0F2B 100%)",
	},
	// Header Section
	headerContainer: {
		padding: "32px 24px 24px",
		color: "white",
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		justifyContent: "flex-start",
	},
	pageTitle: {
		fontSize: "clamp(1.5rem, 5vw + 0.5rem, 2rem)",
		fontWeight: "bold",
		color: "white",
		marginBottom: "4px",
		letterSpacing: "-0.5px",
	},
	pageSubtitle: {
		fontSize: "14px",
		color: "rgba(255, 255, 255, 0.85)",
		fontWeight: "400",
		lineHeight: "1.5",
	},

	// Tabs Section — segmented control
	tabsContainer: {
		display: "flex",
		padding: "0 24px 16px",
	},
	tabsSegmented: {
		display: "flex",
		flex: 1,
		backgroundColor: "rgba(255, 255, 255, 0.18)",
		borderRadius: 999,
		padding: 3,
	},
	tab: {
		flex: 1,
		padding: "10px 0",
		borderRadius: 999,
		border: "none",
		fontSize: "15px",
		fontWeight: "600",
		cursor: "pointer",
		transition: "background-color 0.25s ease, color 0.25s ease",
		backgroundColor: "transparent",
		color: "rgba(255, 255, 255, 0.75)",
		fontFamily: "inherit",
		"&.active": {
			backgroundColor: "#ffffff",
			color: brand?.default,
			boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
		},
	},

	// Cards Container
	cardsContainer: {
		width: "100%",
		backgroundColor: "#F6F6F3",
		display: "flex",
		flexDirection: "column",
		paddingBottom: "50px",
	},

	// Card Styles
	card: {
		backgroundColor: "white",
		borderRadius: "16px",
		padding: "16px",
		marginBottom: "20px",
		boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
		cursor: "pointer",
		transition: "all 0.3s ease",
		"&:hover": {
			boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
			transform: "translateY(-2px)",
		},
	},

	// Card Header (Data)
	cardHeader: {
		display: "flex",
		alignItems: "center",
		marginBottom: "16px",
		paddingBottom: "12px",
		borderBottom: "1px solid #f0f0f0",
	},
	cardDate: {
		fontSize: "14px",
		fontWeight: "500",
		color: "#333",
		letterSpacing: "-0.2px",
	},

	// Card Body (Avatar + Info + Badge)
	cardBody: {
		display: "flex",
		alignItems: "center",
		gap: "12px",
	},
	professionalAvatar: {
		width: "56px",
		height: "56px",
		borderRadius: "50%",
		backgroundColor: "#8B1538",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0,
		overflow: "hidden",
	},
	avatarInitial: {
		fontSize: "24px",
		fontWeight: "bold",
		color: "white",
	},
	cardInfo: {
		flex: 1,
		minWidth: 0,
	},
	professionalName: {
		fontSize: "16px",
		fontWeight: "600",
		color: "#333",
		marginBottom: "4px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	serviceName: {
		fontSize: "14px",
		color: "#666",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	serviceBadge: {
		backgroundColor: "#f5f5f5",
		borderRadius: "50%",
		width: "64px",
		height: "64px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: "8px",
		flexShrink: 0,
		border: "2px solid #e0e0e0",
	},
	badgeText: {
		fontSize: "11px",
		fontWeight: "600",
		color: "#666",
		textAlign: "center",
		lineHeight: "1.2",
		overflow: "hidden",
		textOverflow: "ellipsis",
		display: "-webkit-box",
		"-webkit-line-clamp": 2,
		"-webkit-box-orient": "vertical",
	},

	// Card Footer
	cardFooter: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		paddingTop: "12px",
		borderTop: "1px solid #f0f0f0",
	},
	priceLabel: {
		fontSize: "14px",
		color: "#666",
	},
	paidAmount: {
		fontSize: "14px",
		fontWeight: "600",
		color: "#4CAF50",
	},
	cancelledText: {
		fontSize: "14px",
		fontWeight: "600",
		color: "#d32f2f",
	},

	// Empty State
	verificationText: {
		color: "#999",
		marginTop: "80px",
		fontSize: "16px",
		fontWeight: "500",
		textAlign: "center",
		padding: "0 24px",
	},

	// Legacy styles (mantidos para compatibilidade)
	rectangle: {
		width: "335px",
		height: "130px",
		margin: "20px 20px 12px",
		padding: "8px 16px",
		borderRadius: "5px",
		backgroundColor: "#39376208",
	},
	date: {
		width: "auto",
		height: "15px",
		margin: "0 7px 8px 0",
		fontSize: "12px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.27px",
		color: "#888888",
	},
	hours: {
		height: "15px",
		margin: "9px 50px 4px 0",
		fontSize: "12px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.27px",
		color: "#888888",
		float: "left",
	},
	status: {
		height: "20px",
		margin: "8px 0 8px 6px",
		fontSize: "12px",
		fontWeight: 500,
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.36px",
		textAlign: "right",
		color: " #d30000",
	},
	nameService: {
		height: "20px",
		margin: "4px 97px 8px 0",
		fontSize: "12px",
		fontWeight: 500,
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.36px",
		color: "#474747",
	},
	value: {
		height: "20px",
		margin: "-28px 0 8px 6px",
		fontSize: "16px",
		fontWeight: 500,
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.36px",
		textAlign: "right",
		color: "#3689ea",
	},
	payment: {
		height: "14px",
		margin: "7px 3px 0 80px",
		fontSize: "12px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "normal",
		color: "#474747",
		float: "left",
	},
	total: {
		height: "14px",
		margin: "7px 0 0 6px",
		fontSize: "12px",
		fontWeight: "bold",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "normal",
		textAlign: "right",
		color: "#474747",
	},
	button: {
		height: "36px",
		margin: "15px 5px 15px 0",
		padding: "9px 13.5px 5px 14.5px",
		borderRadius: "18px",
		border: "solid 1px #3689ea",
	},
	buttonName: {
		height: "18px",
		fontSize: "12px",
		fontWeight: "bold",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "normal",
		textAlign: "center",
		color: "#3689ea",
	},
	buttonTab: {
		width: "45%",
		padding: "10px 20px",
		borderRadius: "8px",
		border: "solid 1px #3689ea",
		alignItems: "center",
		fontSize: "14px",
		fontWeight: "bold",
		boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.39)",
		transition: "background-color 0.3s ease, color 0.3s ease",
		backgroundColor: "#ffffff",
		color: "#3689ea",
		"&.active": {
			backgroundColor: "#3689ea",
			color: "#ffffff",
		},
		"&:hover": {
			backgroundColor: "#3689ea",
			color: "#ffffff",
		},
	},

	// Google Calendar Sync Card
	googleSyncCard: {
		display: "flex",
		alignItems: "center",
		padding: "12px 18px",
		backgroundColor: "#f5f5f5",
		cursor: "pointer",
		transition: "background-color 0.2s ease",
		borderRadius: "8px",
		margin: "8px 16px",
		boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
		"&:hover": {
			backgroundColor: "#f5f5f5",
		},
	},
	googleSyncCardActive: {
		display: "flex",
		alignItems: "center",
		padding: "16px 24px",
		cursor: "pointer",
		transition: "background-color 0.2s ease",
		borderRadius: "8px",
		margin: "8px 16px",
		boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
		"&:hover": {
			backgroundColor: "#BBDEFB",
		},
	},
	googleSyncIconContainer: {
		width: "40px",
		height: "40px",
		borderRadius: "8px",
		backgroundColor: "#f5f5f5",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginRight: "16px",
	},
	googleSyncIconContainerActive: {
		width: "40px",
		height: "40px",
		borderRadius: "8px",
		backgroundColor: "#2196F3",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginRight: "16px",
	},
	googleSyncIcon: {
		fontSize: "20px",
		color: "#666",
	},
	googleSyncIconActive: {
		fontSize: "20px",
		color: "white",
	},
	googleSyncTextContainer: {
		flex: 1,
	},
	googleSyncTitle: {
		fontSize: "15px",
		fontWeight: "500",
		color: "#1a1a1a",
		marginBottom: "2px",
	},
	googleSyncTitleActive: {
		fontSize: "15px",
		fontWeight: "500",
		color: "#1565C0",
		marginBottom: "2px",
	},
	googleSyncSubtitle: {
		fontSize: "13px",
		color: "#666",
	},
	googleSyncSubtitleActive: {
		fontSize: "13px",
		color: "#1976D2",
	},
}));

export default MuiStylesCardReservations;
